import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://dnjcqucytdhxobzszaka.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRuamNxdWN5dGRoeG9ienN6YWthIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTYxNjAwMTgsImV4cCI6MjA3MTczNjAxOH0.-7FV7IaGybKSjcy11JUb4Rn-D8Xj2DppaJ5Oi5wNSyg'

if (SUPABASE_URL === 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY === '<ANON_KEY>') {
  throw new Error('Missing Supabase variables')
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})

export default supabase